import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Store } from '@ngrx/store';
import { CookieService } from 'ngx-cookie-service';
// models
import { User } from 'src/app/shared/interfaces/user.interface';
// actions
import { retrieveUser } from 'src/app/states/actions/user.actions';
import { clearSetting, retrieveSetting } from 'src/app/states/actions/setting.action';

@Injectable({ providedIn: 'root' })
export class StoreService {
  constructor(@Inject(PLATFORM_ID) private readonly platformId: any, private store: Store, private cookieService: CookieService) {}

  public initRetriveStoreData() {
    this.checkPreviousStore();
    this.storeExistingUser();
    this.storeExistingGlobalSetting();
  }

  private storeExistingUser() {
    if (this.platformId === 'browser') {
      const userData = localStorage.getItem('user-data');
      const userToken = this.cookieService.get('X-Auth-Token');
      if (!userData && !userToken) return;
      const payload: User = {
        isLoggedIn: false,
        data: userData ? JSON.parse(userData) : null,
        token: userToken ? userToken : null,
      };
      if (payload.token && payload.data) payload.isLoggedIn = true;
      this.store.dispatch(retrieveUser({ payload: payload }));
    }
  }

  private storeExistingGlobalSetting() {
    if (this.platformId === 'browser') {
      const data = localStorage.getItem('setting-data');
      if (!data) return;
      const payload = JSON.parse(data);
      this.store.dispatch(retrieveSetting({ payload }));
    }
  }

  private checkPreviousStore(){
    if (this.platformId === 'browser') {
      const data = localStorage.getItem('setting-data');
      if (!data) return;
      const payload = JSON.parse(data);
      if('default_language' in payload) this.store.dispatch(clearSetting());
    }
  }

}
